import { useToLocaleDateAktivita } from "b2b/i18n";

import createBaseRenderer from "./createBaseRenderer";

export default createBaseRenderer({
  name: "dateDayMonthTime",
  placeholderText: "17. března, 09:09",
  content: ({ val }) => useToLocaleDateAktivita()(val)
});
